import { useCallback, useRef } from "react";

import { awsWafTokenHeaders } from "./awsWafToken";

// Fetches the WAF token when the user first touches the form (wire to the form's onFocusCapture) so
// it's ready by the time they submit. Runs once, and not on page load — so scrapers don't trigger it.
export function useAwsWafWarmup(): () => void {
  const warmed = useRef(false);
  return useCallback(() => {
    if (warmed.current) {
      return;
    }
    warmed.current = true;
    void awsWafTokenHeaders();
  }, []);
}
